import type { FC } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { withBamLayoutSelector } from '@redux/user/selectors';
import { useSelector } from 'react-redux';
import { Stack } from '@mui/material';

import ExperienceBar from './ExperienceBar';
import { TimeContainer, RemainingTime, TimeSlider } from './SliderContainer.style';

interface ISliderContainer {
  timeSliderValue: number;
  timeSliderMax: number;
  handleTimeSliderChange: (value: number | number[]) => void;
  handleTimeSliderChangeCommitted: () => void;
  remainingTime: string | null;
  controlsDisabled: boolean;
}

const SliderContainer: FC<ISliderContainer> = ({
  timeSliderValue,
  timeSliderMax,
  handleTimeSliderChange,
  handleTimeSliderChangeCommitted,
  remainingTime,
  controlsDisabled,
}) => {
  const colors = useSelector(colorsSelector);
  const withBamLayout = useSelector(withBamLayoutSelector);
  return (
    <TimeContainer>
      <TimeSlider
        colors={colors}
        value={timeSliderValue}
        max={timeSliderMax}
        onChange={(_, value) => handleTimeSliderChange(value)}
        onChangeCommitted={handleTimeSliderChangeCommitted}
        disabled={controlsDisabled}
      />
      <Stack sx={{ width: 60 }} direction={'row'}>
        <RemainingTime>{remainingTime}</RemainingTime>
        {withBamLayout && remainingTime && <ExperienceBar />}
      </Stack>
    </TimeContainer>
  );
};

export default SliderContainer;
